<template>
  <div>
    <Header />
    <b-container class="my-4">
      <h1>Nosotros</h1>
      <p>
        Hoops Yard, es un nuevo centro deportivo de tres canchas de basketball, gimnasio de pesas, amplio estacionamiento, duchas, y valores agregados como Food Trucks, Nutrition Bar, etc.
        <br />Ofrecemos un ambiente familiar deportivo (Volleyball y Basketball) para que puedan compartir después de un día laboral.
      </p>
      <p>Organizamos:</p>
      <ul>
        <li>Birrias</li>
        <li>Alquiler de canchas por hora para grupos privados</li>
        <li>Juegos parte del Hoops 5×5 Challenge</li>
        <li>Ligas empresariales internas masculinas, femeninas y mixtas</li>
        <li>Ligas interempresariales masculinas, femeninas, mixtas</li>
        <li>Torneos de un día</li>
        <li>Cuadrangulares</li>
        <li>Eventos deportivos en general</li>
      </ul>
      <p>Estamos ubicados en Juan Díaz, diagonal al Crown Casino del Hipódromo, Parque Logístico Metropolitano.</p>
      <ul class="nav mb-5 lead justify-content-center">
        <li title="Usa Waze para conducir a Hoops Yard" class="nav-item"><a href="https://waze.com/ul/hd1x7rtkdw" target="_self" class="nav-link">Waze</a></li>
        <li title="Usa Google maps para localizar a Hoops Yard" class="nav-item"><a href="https://goo.gl/maps/PuPY5eYCSvuLCWgF9" target="_self" class="nav-link">Google maps</a></li>
      </ul>
      <p><b-img src="../assets/map.png" fluid alt="Hoops Yard"></b-img></p>
      <hr />
      <Jumbo
        label="¿Alguna pregunta?"
      />
    </b-container>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/home/Header.vue'
import Jumbo from '@/components/home/Jumbo.vue'
import Footer from '@/components/home/Footer.vue'
export default {
  components: {
    Header,
    Jumbo,
    Footer
  }
}
</script>\
